export const validatePhoneReg = /(^1[3456789]\d{9}$)|(^234\d{8}$)/;

export const validateEmailReg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;

export function pickPhoneNumberOrEmail(value) {
  if (value === undefined) {
    return null;
  }
  // eslint-disable-next-line no-prototype-builtins
  if (value instanceof Object && value.hasOwnProperty("phoneNumber")) {
    const validateValue = value.phoneNumber;
    if (validatePhoneReg.test(validateValue.toString())) {
      return value;
    }
    if (validateEmailReg.test(validateValue.toString())) {
      const result = {
        ...value,
        email: validateValue,
      };
      Reflect.deleteProperty(result, "phoneNumber");
      return result;
    }
  }
  return value;
}
